// extracted by mini-css-extract-plugin
module.exports = {"expandedButton":"expanded-button_expandedButton__vRg1z","text":"expanded-button_text__FfE8Y","icon":"expanded-button_icon__w66Tb"};